import { Controller } from "stimulus";

export default class extends Controller {
  static targets = []
  
  removeImageFromEditor() {
    const model = window.editor.model;

    model.change(writer => {
      for(const child of model.document.getRoot().getChildren()) {
        if (child.is('element', 'imageBlock') || child.is('element', 'imageInline')) {
          var imgSrc = child.getAttribute('src');
          if (imgSrc.includes(this.element.dataset.blobSignedId)) {
            writer.remove(child);
            console.log("Image block removed from editor")
          }
        }
      } 
    })
  }


  insertImageIntoEditor() {
    const model = window.editor.model;
    var fullImageUrl = this.element.dataset.fullImageUrl;

    model.change(writer => {
      const imageElement = writer.createElement('imageBlock', {
        src: fullImageUrl,
      })

      window.editor.editing.view.focus();

      model.insertContent(imageElement, model.document.selection)
    })
  }
}

